import React from 'react'

const MobilepayDone = () => {
  return (
    <div>MobilepayDone</div>
  )
}

export default MobilepayDone